// extracted by mini-css-extract-plugin
export default {"button":"m022zm","hoverColor":"n1i5ma","calendar":"miZCfi","link":"aUkG34","linkText":"kaP5hc","fullWidth":"a2w9Ux"};